// pocketModeBus.ts
// ================
//
// Wave 14ca-fix64: Pocket-Mode (OLED-Schwarz-Overlay fuer Energie-Sparen).
//
// Idee: alle aktuellen iPhones (X+) und Pixel-Phones haben OLED-Displays.
// Pure-schwarze Pixel auf OLED sind PHYSIKALISCH ausgeschaltet — null
// Stromverbrauch. Wenn der User das Handy in die Hosentasche steckt
// waehrend einer Recording-Session, koennen wir das Display vollstaendig
// schwarz lassen → Wake-Lock haelt die App aktiv (kein iOS-JS-Suspend),
// GPS / Recording laufen normal weiter, ABER der Display-Verbrauch
// (typischerweise der groesste Single-Akku-Drainer auf'm Bike) faellt
// gegen Null.
//
// Vorteil gegenueber "Display einfach ausgehen lassen":
//   - Display aus → iOS pausiert die PWA → kein GPS, kein Recording.
//   - Pocket-Mode (schwarz, Wake-Lock aktiv) → JS laeuft weiter, GPS
//     liefert weiter Punkte, nur das Display ist physikalisch dunkel.
//
// Limits:
//   - Brightness-API existiert im Web nicht. User muss manuell die
//     System-Helligkeit runterdrehen fuer maximalen Effekt — die paar
//     nicht-schwarzen Pixel (Status-Pill) profitieren davon.
//   - Wenn der Power-Button durch Hosentaschen-Druck gedrueckt wird, geht
//     iOS in echten Sleep — auch der Pocket-Mode kann das nicht verhindern.
//     Trick: User kann Auto-Lock in iOS-Settings auf "Never" stellen
//     waehrend Rides — dann passiert das nicht.
//
// Entsperrung: identisch zu Rain-Mode → 3 Finger 2 Sekunden halten. Eine
// Geste fuer alle Lock-Modi ist konsistenter und der User muss nicht
// ueberlegen was er gerade aktiviert hatte.

type Listener = (active: boolean) => void;

class PocketModeBus {
  private active = false;
  private readonly listeners = new Set<Listener>();

  get(): boolean {
    return this.active;
  }

  activate(): void {
    if (this.active) return;
    this.active = true;
    this.notify();
  }

  deactivate(): void {
    if (!this.active) return;
    this.active = false;
    this.notify();
  }

  toggle(): void {
    this.active = !this.active;
    this.notify();
  }

  subscribe(listener: Listener): () => void {
    this.listeners.add(listener);
    return () => {
      this.listeners.delete(listener);
    };
  }

  private notify(): void {
    for (const l of this.listeners) l(this.active);
  }
}

export const pocketModeBus = new PocketModeBus();
